import { ca } from '@cian/analytics';
import { IJsonQuery } from 'shared/json_query';

import { getDeveloperContactsLabel } from '../../serp/components/header/developers_contacts';

type TNewbuildingComparisonAction = 'Add' | 'Remove' | 'click_popup_add' | 'click_popup_remove';

function trackNewbuildingComparisonEvent(newbuildingId: number, action: TNewbuildingComparisonAction, label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action,
    label,
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
  });
}

export function trackAddNewbuildingToComparison(newbuildingId: number) {
  trackNewbuildingComparisonEvent(newbuildingId, 'Add', getDeveloperContactsLabel(null));
}

export function trackRemoveNewbuildingFromComparison(newbuildingId: number) {
  trackNewbuildingComparisonEvent(newbuildingId, 'Remove', getDeveloperContactsLabel(null));
}

export function trackClickAddComparisonPopup(newbuildingId: number) {
  trackNewbuildingComparisonEvent(newbuildingId, 'click_popup_add', 'to_compare');
}

export function trackClickRemoveComparisonPopup(newbuildingId: number) {
  trackNewbuildingComparisonEvent(newbuildingId, 'click_popup_remove', 'to_compare');
}

/**
 * Тултип флайта «Сравнение ЖК» у кнопки сравнения в шапке ЖК.
 */
function trackCompareFlightTooltipEvent(jsonQuery: IJsonQuery, action: 'Show' | 'Click', label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJKPromo',
    action,
    label,
    page: {
      pageType: 'Listing',
    },
    sc: jsonQuery,
  });
}

export function trackCompareFlightTooltipShow(jsonQuery: IJsonQuery) {
  trackCompareFlightTooltipEvent(jsonQuery, 'Show', 'tooltip');
}

export function trackCompareFlightTooltipAboutClick(jsonQuery: IJsonQuery) {
  trackCompareFlightTooltipEvent(jsonQuery, 'Click', 'tooltip_about_link');
}
